import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
export const ChatListEndpointParams = z.object({
    /** Load chats with last event before this timestamp (for pagination). */
    beforeTimestamp: z.optional(z.number()),
    /** Number of chats to return (1-100, default 20). */
    count: z._default(z.number().check(z.minimum(1)).check(z.maximum(100)), 20),
});
export const ChatListEndpoint = defineEndpoint({
    name: 'ChatList',
    input: ChatListEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=ChatListEndpoint.js.map